var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return false
    ? _c("v-app-bar", [
        _c("span", { staticClass: "title ml-3 mr-5" }, [
          _vm._v(" " + _vm._s(_vm.$t("app.name")) + " "),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }